import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../openapi';
import { CustomValidator, fromToDate } from '../../../../../../common/forms/custom.validators';

@Injectable()
export class CemeterySiteDetailsForm extends AppForm {

  public cemeteryNames: string[] = [
    'Cmentarz Komunalny w Łozinie',
    'Cmentarz Komunalny w Borowej'
  ];

  constructor() {
    super({
      cemeteryName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      graveType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      graveSector: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      graveRow: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      graveNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      soleGraveAdmin: new FormControl(false, [Validators.required])
    }, {
      validators: [fromToDate('dateOfBirth', 'dateOfDeath')]
    });
  }

  public get soleGraveAdmin(): FormControl {
    return this.get('soleGraveAdmin') as FormControl;
  }

  public get numberOfRemainingDisposers(): FormControl | null {
    return this.get('numberOfRemainingDisposers') as FormControl | null;
  }

  public soleGraveAdminChange(v: boolean): void {
    if (!v) {
      this.addControl('numberOfRemainingDisposers', new FormControl(1, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(1)]
      }));
    } else {
      this.removeControl('numberOfRemainingDisposers');
    }
  }

  public createPersonDataControls(): void {
    this.addControl('personFirstName', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    this.addControl('personLastName', new FormControl(null, [Validators.required, Validators.maxLength(255)]));

    this.addControl('dateOfBirth', new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())] }));
    this.addControl('dateOfDeath', new FormControl(null, { validators: [Validators.required, CustomValidator.isValidDateFormat()] }));

    this.addControl('declarationOfDataAccuracy', new FormControl(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    }));
  }

  private get declarationOfDataAccuracy(): FormControl | null {
    return this.get('declarationOfDataAccuracy') as FormControl | null;
  }

  private get personFirstName(): FormControl | null {
    return this.get('personFirstName') as FormControl | null;
  }

  private get personLastName(): FormControl | null {
    return this.get('personLastName') as FormControl | null;
  }

  private get dateOfBirth(): FormControl | null {
    return this.get('dateOfBirth') as FormControl | null;
  }

  private get dateOfDeath(): FormControl | null {
    return this.get('dateOfDeath') as FormControl | null;
  }

  public get showPersonDataControls(): boolean {
    return !!this.personFirstName
      && !!this.personLastName
      && !!this.declarationOfDataAccuracy
      && !!this.dateOfBirth
      && !!this.dateOfDeath;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.soleGraveAdminChange(!!value?.soleGraveAdmin);
    super.patchFormValues({
      cemeteryName: value?.cemeteryName || '',
      graveSector: value?.graveSector,
      graveRow: value?.graveRow,
      graveNumber: value?.graveNumber,
      graveType: value?.graveType || '',
      soleGraveAdmin: !!value?.soleGraveAdmin,
      dateOfBirth: value?.dateOfBirth,
      dateOfDeath: value?.dateOfDeath,
      numberOfRemainingDisposers: value?.numberOfRemainingDisposers || 1
    });
    this.personFirstName?.setValue(value?.personFirstName);
    this.personLastName?.setValue(value?.personLastName);
    this.declarationOfDataAccuracy?.setValue(!!value?.declarationOfDataAccuracy);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      numberOfRemainingDisposers: this.numberOfRemainingDisposers?.value || 1
    };
  }
}
